import { render, staticRenderFns } from "./exchanges-list.vue?vue&type=template&id=4f8cab3a&"
import script from "./exchanges-list.vue?vue&type=script&lang=js&"
export * from "./exchanges-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports